<template>
    <img src="../../assets/divapp_logo.png"/>
</template>
